/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const Kinds = {
  Log: "log",
  Span: "span",
} as const;
export type Kinds = ClosedEnum<typeof Kinds>;

/**
 * Payload for listing event feed filter facets
 */
export type GetEventFacetsPayload = {
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * Optional signal kind filter. Empty means facets from both logs and spans.
   */
  kinds?: Array<Kinds> | undefined;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export const Kinds$outboundSchema: z.ZodMiniEnum<typeof Kinds> = z.enum(Kinds);

/** @internal */
export type GetEventFacetsPayload$Outbound = {
  from: string;
  kinds?: Array<string> | undefined;
  to: string;
};

/** @internal */
export const GetEventFacetsPayload$outboundSchema: z.ZodMiniType<
  GetEventFacetsPayload$Outbound,
  GetEventFacetsPayload
> = z.object({
  from: z.pipe(z.date(), z.transform(v => v.toISOString())),
  kinds: z.optional(z.array(Kinds$outboundSchema)),
  to: z.pipe(z.date(), z.transform(v => v.toISOString())),
});

export function getEventFacetsPayloadToJSON(
  getEventFacetsPayload: GetEventFacetsPayload,
): string {
  return JSON.stringify(
    GetEventFacetsPayload$outboundSchema.parse(getEventFacetsPayload),
  );
}
